// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d2-2";
export var aiChatCartContainerExit = "_d2-4";
export var aiChatContainerLarge = "_d2-0";
export var aiChatContainerSmall = "_d2-1";
export var aiChatIcon = "_d2-6";
export var slideInFromRight = "_d2-3";
export var slideOutToRight = "_d2-5";